/** ************** Banner ************** */
$(function () {
  function initBannerCarousel() {
    const bannerList = window.banner;
    const indexContainer = $(".bd ul");
    const indicatorContainer = $(" #slideBox.slideBox .hd ul");
    const isLoggedIn = $(".before-login.hide").length !== 0;

    bannerList &&
      bannerList.length !== 0 &&
      bannerList.forEach(function (item) {
        const { imageUrl, redirectUrl, redirectGroup, redirectPage, bannerType } = item;

        if (imageUrl && redirectGroup !== 1 && (redirectGroup !== 4 || redirectUrl !== "/faq")) {
          /**
           * Redirect Group Option
           * 0 - Promo
           * 1 - Join Us
           * 2 - Lottery
           * 3 - Product
           * 4 - Others inner page (Loyalty, Customer Service)
           * 5 - 自定义
           */

          const indicator = $(`<li></li>`);
          const banner = $(`
            <li>
                <img ${redirectUrl ? `data-redirect=${redirectUrl}` : ""} class="img" src="${imageUrl}"/>
            </li>
          `);

          banner.click(() => {
            if (redirectGroup === 0) {
              $("#modalPromo").addClass("active");
            } else {
              window.initBannerCarouselRedirection({
                redirectUrl,
                redirectGroup,
                redirectPage,
                isLoggedIn,
              });
            }
          });

          /**
           * index append 首页type banner, promo append 优惠活动type banner
           * 轮播图类型 bannerType
           * 0 - 首页
           * 1 - 优惠活动
           * 2 - 其他
           */
          if (bannerType === 0) {
            indexContainer.append(banner);
            indicatorContainer.append(indicator);
          }
        }
      });

    if (bannerList && bannerList.length) {
      $(".slideBox").slide({ mainCell: ".bd ul", effect: "leftLoop", autoPlay: true, mouseOverStop: false });
    }
  }

  if (Pace) {
    Pace.on("done", initBannerCarousel);
  } else {
    $(window).load(initBannerCarousel);
  }
});

/** ************** Promo ************** */
$(function () {
  if (window.promo) {
    renderPromo(window.promo);
  } else {
    Object.defineProperty(window, "promo", {
      set: function (data) {
        renderPromo(data);
      },
    });
  }

  function registerPromo(promoId) {
    api.registerPromo(promoId);
  }

  function renderPromo(promoData) {
    if (Array.isArray(promoData)) {
      const promoWrapper = $("#modalPromo");
      const promohash = location.hash !== "" ? location.hash.split("#")[1] : "";

      promoData.forEach(function (value, index) {
        const promoId = value.promoId;
        const requestToJoin = value.requestToJoin;
        const firstDepositPromoJoinMsg = value.firstDepositPromoJoinMsg;

        const promoSidebarItem = $(
          `<div class="modal-sidebar-item ${index === 0 ? "active" : ""}" data-type="${
            value.type
          }" data-id="${promoId}">${value.title}</div>`
        );

        const promoContentItem = $(`<div class="modal-right-content-item ${
          index === 0 ? "active" : ""
        }" data-id="${promoId}">
                                      <div class="content-item-head">
                                        ${value.imagePath ? `<img src="${value.imagePath}" />` : ""}
                                        <h3>${value.title}</h3>
                                      </div>
                                      <div class="content-item-body">
                                        ${value.content}
                                        ${
                                          requestToJoin
                                            ? `
                                         <div class="content-item-footer">
                                         ${
                                           firstDepositPromoJoinMsg
                                             ? `
                                                     <div class="content-item-footer--info">
                                                       ${firstDepositPromoJoinMsg}
                                                     </div>
                                                   `
                                             : `
                                                     <button
                                                       class="content-item-footer--register-promo"
                                                       data-promoid="${promoId}"
                                                     >
                                                       申请参与
                                                     </button>
                                                   `
                                         }
                                         </div>
                                        `
                                            : ""
                                        }
                                      </div>
                                  </div>`);

        promoWrapper.find(".modal-sidebar").append(promoSidebarItem);
        promoWrapper.find(".modal-right-content").append(promoContentItem);
      });
    }
  }

  $(document).on("click", ".modal-sidebar-item", function (e) {
    e.preventDefault();
    const currentId = $(this).data("id");

    $(this).addClass("active").siblings(".modal-sidebar-item").removeClass("active");
    $(`.modal-right-content .modal-right-content-item[data-id='${currentId}']`)
      .addClass("active")
      .siblings(".modal-right-content-item")
      .removeClass("active");
  });

  $(document).on("click", ".content-item-footer--register-promo", function (e) {
    e.preventDefault();
    const promoId = $(this).data("promoid");
    registerPromo(promoId);
  });
});

$(document).ready(function () {
  // $(".slideBox").slide({ mainCell: ".bd ul", effect: "leftLoop", autoPlay: true, mouseOverStop: false });

  function bindDownloadBtn() {
    $(".app-dialog").click(function (e) {
      e.preventDefault();
      showOverlay("ios");
    });
  }
  function showOverlay(mode) {
    $("body").addClass("noscroll");
    $(".overlay").fadeIn();
    $(".modal-popup").fadeIn();
    $(".modal-popup").find(".button-group").addClass(mode);
    $(".modal-popup")
      .find(".instruction ul." + mode)
      .show();
    bindOverlayButton();
    closeOverlay(mode);
  }
  function bindOverlayButton() {
    $(".button-group .ios-download").click(function (e) {
      e.preventDefault();
      showOverlay("ios");
      hideMenu("android");
    });
    $(".button-group .android-download").click(function (e) {
      e.preventDefault();
      showOverlay("android");
      hideMenu("ios");
    });
  }
  function closeOverlay(mode) {
    $(".overlay").click(function (e) {
      e.preventDefault();
      $("body").removeClass("noscroll");
      hideMenu(mode);
      $(this).fadeOut();
      $(".modal-popup").fadeOut();
    });
  }
  function hideMenu(mode) {
    $(".modal-popup").find(".button-group").removeClass(mode);
    $(".modal-popup")
      .find(".instruction ul." + mode)
      .hide();
  }
  bindDownloadBtn();

  /** Open / Close Modal (Promo) */
  $(".aPromo").on("click", function () {
    $("#modalPromo").addClass("active");
  });

  $(".btnCloseModal").on("click", function () {
    $(this).closest(".modal").removeClass("active");
  });
});
